<template>
  <div class="home-wrapper">

    <!--
    <div id="overlay" @click="disableOverlay">
      <div id="text">
        <button id="x" @click="disableOverlay">X</button>
        <a href="https://www.alcomet.bg/news/ALUMINIUM-Exhibition-2024">
          <img src="static/img/home/banner-2024.jpg" />
        </a>
      </div>
    </div>
    -->

    <app-header-curve></app-header-curve>
    <app-markets></app-markets>
    <app-overview></app-overview>
    <app-news></app-news>
  </div>
</template>

<script>
import HeaderCurve from "./shared/HeaderCurve";
import Markets from "./home/Markets";
import Overview from "./home/Overview";
import News from "./home/News";
export default {
  components: {
    appHeaderCurve: HeaderCurve,
    appMarkets: Markets,
    appOverview: Overview,
    appNews: News
  },
  methods: {
    disableOverlay() {
      document.getElementById("overlay").style.display = "none";
    },
  },
};
</script>


<style scoped>
#x {
  position: absolute;
  top: -20px;
  right: -10px;
  background: #036663;
  color: white;
  z-index: 9999;
  font-size: 24px;
  padding: 10px 15px;
  border: none;
}
#overlay {
  position: fixed;
  display: block;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 9900;
  cursor: pointer;
}

#text {
  position: absolute;
  top: 50%;
  left: 50%;
  font-size: 50px;
  color: white;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
}
@media screen and (max-width: 992px) {
  #text {
    width: 95%;
  }
  #text img {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue